import { useSetAtom } from 'jotai'
import React from 'react'
import { useTranslation } from 'react-i18next'

import {
  StyledButton,
  type StyledButtonProps,
} from '~/components/elements/StyledButton'

import { dialogInfoAtom } from '../atoms'
import { type StrategyMemo } from '../hooks/useArchivedStrategyMemosInfiniteQuery'

export type DeleteButtonProps = {
  strategyMemo: StrategyMemo
}

export const DeleteButton = ({ strategyMemo }: DeleteButtonProps) => {
  const { t } = useTranslation()
  const setDialogInfo = useSetAtom(dialogInfoAtom)
  const handleClick = React.useCallback<
    EH<StyledButtonProps, 'onClick'>
  >(() => {
    setDialogInfo({ dialogType: 'delete', strategyMemo })
  }, [strategyMemo, setDialogInfo])

  return (
    <StyledButton
      disabled={!strategyMemo.isDeletable}
      fillMode="outline"
      icon="delete"
      onClick={handleClick}
    >
      {t('delete_forever')}
    </StyledButton>
  )
}
